import { UserFriendlyError } from './user-friendly-error'

/**
 * Enables type-checking that is not affected by having multiple versions of
 * this library installed
 */
// The string here is used as the type description for the type checker
const MARKER_SYMBOL = Symbol.for('@attain-apps/AuthError')

/**
 * User is not authenticated or not authorized to execute this action
 */
export class AuthError extends UserFriendlyError {
  // NOTE: must be all upper case to avoid naming collision with the class name
  public static override readonly NAME: string = 'AuthError'
  public override readonly name: string = AuthError.NAME

  // Used by TypeChecker
  private readonly [MARKER_SYMBOL] = true as const

  constructor(actualError?: Error) {
    // TODO: should we leave the message generic to avoid exposing any info? Or
    // should we add specific info to help users figure out what it is that they
    // are not authorized to do?
    super('User is not authorized to execute this request.', actualError)
  }
}
export namespace AuthError {
  // NOTE: not using @attain-apps/type-guards as that would introduce circular imports
  export function isAuthError(val: unknown): val is AuthError {
    return !!(val as AuthError)?.[MARKER_SYMBOL]
  }
}
